module.exports = __webpack_public_path__ + "img/rules_2.c0f5bdf2.png";